import * as style from './style.module.sass'

type SnsIconProps = {
  name:
    | 'x'
    | 'facebook'
    | 'line'
    | 'note'
    | 'linkedin'
    | 'linkedin-skelton'
    | 'instagram'
  type?: 'normal' | 'circle' | 'bigCircle'
}
const SnsIcon = ({ name, type = 'normal' }: SnsIconProps) => {
  let svg = // x icon
    (
      <svg width="19" height="20" viewBox="0 0 19 20" fill="none">
        <path
          d="M11.1077 8.06815L18.0558 0.0229492H16.4093L10.3763 7.00849L5.55768 0.0229492H0L7.28666 10.5863L0 19.0229H1.64658L8.01766 11.646L13.1064 19.0229H18.6641L11.1073 8.06815H11.1077ZM8.85247 10.6794L8.11418 9.62751L2.23987 1.25764H4.76892L9.50956 8.01239L10.2479 9.06427L16.4101 17.8444H13.8811L8.85247 10.6798V10.6794Z"
          fill="currentColor"
        />
      </svg>
    )

  switch (name) {
    case 'note':
      svg = (
        <svg width="53" height="25" viewBox="0 0 53 25" fill="none">
          <mask
            id="mask0_10801_94777"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="53"
            height="25"
          >
            <path
              d="M52.1415 0.387207H0.712891V24.3872H52.1415V0.387207Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_10801_94777)">
            <path
              d="M7.44162 7.54771C5.55455 7.4959 2.91266 7.59952 0.994141 7.59952V17.299H3.74087V9.96222C3.74087 9.96222 6.18358 9.87932 7.06421 9.98294C7.89242 10.0762 8.19645 10.584 8.2279 11.641C8.24887 12.843 8.2279 13.4752 8.2279 17.299H10.9746C10.9746 17.299 11.0061 12.9259 10.9746 11.4026C10.9327 8.69797 9.97868 7.60989 7.44162 7.54771Z"
              fill="currentColor"
            />
            <path
              d="M20.148 7.51709C17.4328 7.51709 15.2207 9.71398 15.2207 12.4186C15.2207 15.1233 17.4328 17.3202 20.148 17.3202C22.8633 17.3202 25.0754 15.1233 25.0754 12.4186C25.0754 9.71398 22.8633 7.51709 20.148 7.51709ZM20.148 14.9782C18.7223 14.9782 17.5691 13.828 17.5691 12.4083C17.5691 10.9886 18.7223 9.83833 20.148 9.83833C21.5738 9.83833 22.727 10.9886 22.727 12.4083C22.727 13.8383 21.5738 14.9782 20.148 14.9782Z"
              fill="currentColor"
            />
            <path
              d="M51.0324 12.4186C51.0324 9.71398 48.8204 7.51709 46.1051 7.51709C43.3898 7.51709 41.1777 9.71398 41.1777 12.4186C41.1777 14.0041 41.9116 15.3616 43.0543 16.2632C43.8511 16.885 44.9624 17.3202 46.451 17.3202C47.1744 17.3202 49.051 17.1233 50.4034 15.6414L49.2921 14.1699C48.8204 14.5844 47.6357 15.1648 46.6922 15.1648C45.497 15.1648 44.7736 14.9368 44.2495 14.4497C43.9245 14.1596 43.6938 13.714 43.589 13.1648H50.959C51.001 12.9161 51.0324 12.6777 51.0324 12.4186ZM43.61 11.5275C43.8825 10.3772 44.7003 9.52745 46.0946 9.52745C47.5518 9.52745 48.3171 10.4394 48.5688 11.5275H43.61Z"
              fill="currentColor"
            />
            <path
              d="M34.4057 6.6145H31.8372V9.33989H29.1953V11.7233H31.8372V14.5523H34.4057V11.7233H37.0476V9.33989H34.4057V6.6145Z"
              fill="currentColor"
            />
          </g>
        </svg>
      )
      break
    case 'facebook':
      svg = (
        <svg width="25" height="26" viewBox="0 0 25 26" fill="none">
          <ellipse
            cx="12.685"
            cy="13.0173"
            rx="11.933"
            ry="12.0392"
            fill="currentColor"
          />
          <g clipPath="url(#clip0_7312_56433)">
            <path
              d="M24.8562 13.0173C24.8562 6.36824 19.5096 0.978027 12.9144 0.978027C6.31922 0.978027 0.972656 6.36824 0.972656 13.0173C0.972656 18.6632 4.82841 23.4009 10.0298 24.7021V16.6965H7.56737V13.0173H10.0298V11.4319C10.0298 7.33427 11.8693 5.43496 15.8597 5.43496C16.6164 5.43496 17.9218 5.58472 18.4559 5.73401V9.06888C18.174 9.03902 17.6844 9.0241 17.0764 9.0241C15.1184 9.0241 14.3618 9.77197 14.3618 11.7161V13.0173H18.2624L17.5922 16.6965H14.3618V24.9684C20.2748 24.2484 24.8566 19.1727 24.8566 13.0173H24.8562Z"
              fill="currentColor"
            />
            <path
              d="M17.5913 16.6966L18.2614 13.0174H14.3608V11.7162C14.3608 9.77208 15.1174 9.0242 17.0754 9.0242C17.6835 9.0242 18.1731 9.03913 18.4549 9.06898V5.73411C17.9209 5.58435 16.6154 5.43506 15.8588 5.43506C11.8683 5.43506 10.0288 7.33437 10.0288 11.432V13.0174H7.56641V16.6966H10.0288V24.7022C10.9526 24.9333 11.9189 25.0566 12.9134 25.0566C13.4031 25.0566 13.886 25.0263 14.3603 24.9685V16.6966H17.5908H17.5913Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_7312_56433">
              <rect
                width="23.8835"
                height="24.0785"
                fill="white"
                transform="translate(0.972656 0.978027)"
              />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case 'line':
      svg = (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <g clipPath="url(#clip0_10481_575697)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.0469 7.66179C15.0469 4.14001 11.6825 1.27417 7.54688 1.27417C3.41187 1.27417 0.046875 4.14001 0.046875 7.66179C0.046875 10.8195 2.715 13.4643 6.31938 13.9641C6.56375 14.0192 6.89563 14.1334 6.98 14.3525C7.05563 14.5512 7.02938 14.8628 7.00437 15.0642L6.8975 15.7378C6.86438 15.9366 6.74625 16.5158 7.54688 16.1622C8.3475 15.808 11.8663 13.4932 13.4394 11.5922C14.5262 10.3413 15.0469 9.07142 15.0469 7.66179ZM3.17938 5.95961C3.26 5.95961 3.32562 6.02848 3.32562 6.1131V8.83725H4.755C4.83563 8.83725 4.90062 8.90547 4.90062 8.99009V9.5424C4.90062 9.62701 4.83563 9.69589 4.755 9.69589H2.65313C2.61375 9.69589 2.57875 9.67949 2.5525 9.65325L2.55187 9.65259L2.55063 9.65128L2.55 9.65063L2.54812 9.64866C2.52312 9.62111 2.5075 9.58372 2.5075 9.54305V6.1131C2.5075 6.02848 2.5725 5.95961 2.65313 5.95961H3.17938ZM12.5494 5.95961C12.63 5.95961 12.695 6.02848 12.695 6.1131V6.66541C12.695 6.75002 12.63 6.8189 12.5494 6.8189H11.12V7.3981H12.5494C12.63 7.3981 12.695 7.46698 12.695 7.55159V8.1039C12.695 8.18852 12.63 8.25739 12.5494 8.25739H11.12V8.83725H12.5494C12.63 8.83725 12.695 8.90613 12.695 8.99009V9.5424C12.695 9.62701 12.63 9.69589 12.5494 9.69589H10.4475C10.4081 9.69589 10.3725 9.67949 10.3463 9.65325L10.3444 9.65063L10.3425 9.64866C10.3175 9.62111 10.3012 9.58372 10.3012 9.54305V6.1131C10.3012 6.07243 10.3169 6.03504 10.3419 6.00749L10.3444 6.00487L10.3463 6.0029C10.3725 5.97666 10.4081 5.95961 10.4475 5.95961H12.5494ZM6.02313 5.96026C6.10375 5.96026 6.16937 6.02848 6.16937 6.1131V9.54305C6.16937 9.62701 6.10375 9.69589 6.02313 9.69589H5.49688C5.41625 9.69589 5.35063 9.62701 5.35063 9.54305V6.1131C5.35063 6.02848 5.41625 5.96026 5.49688 5.96026H6.02313ZM7.3525 5.96026H7.3575L7.365 5.96092L7.37313 5.96158L7.37938 5.96223L7.3875 5.9642L7.3925 5.96617L7.40125 5.96879L7.40625 5.97076L7.41438 5.97469L7.41875 5.97666L7.42687 5.98125L7.43125 5.98388L7.43875 5.98978L7.4425 5.9924L7.45062 5.99962L7.45312 6.00224L7.46187 6.01143L7.46313 6.01274L7.47437 6.02783L8.97188 8.15047V6.1131C8.97188 6.02848 9.0375 5.96026 9.11812 5.96026H9.64375C9.725 5.96026 9.79 6.02848 9.79 6.1131V9.54305C9.79 9.62701 9.725 9.69589 9.64375 9.69589H9.11812L9.08063 9.69064L9.07812 9.68998L9.06875 9.6867L9.06437 9.68474L9.05688 9.68211L9.05 9.67818L9.04562 9.67621L9.03687 9.67031L9.03563 9.66899L8.99813 9.63095L7.49875 7.50568V9.54305C7.49875 9.62701 7.43375 9.69589 7.3525 9.69589H6.82687C6.74625 9.69589 6.68062 9.62701 6.68062 9.54305V6.1131C6.68062 6.02848 6.74625 5.96026 6.82687 5.96026H7.3525Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_10481_575697">
              <rect
                width="15"
                height="15"
                fill="white"
                transform="translate(0.046875 0.92041)"
              />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case 'linkedin':
      svg = (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
          <rect width="22" height="22" rx="8" fill="white" />
          <path
            d="M18.7407 18.7422H15.4815V13.6418C15.4815 12.4202 15.4611 10.8626 13.7907 10.8626C12.1204 10.8626 11.8352 12.186 11.8352 13.5604V18.7524H8.57592V8.25639H11.7028V9.69182H11.7435C12.3852 8.60252 13.5667 7.95098 14.8296 7.9917C18.1296 7.9917 18.7407 10.1601 18.7407 12.9903V18.7524V18.7422ZM4.88888 6.81078C3.83981 6.81078 2.99444 5.96581 2.99444 4.91723C2.99444 3.86865 3.83981 3.02368 4.88888 3.02368C5.93796 3.02368 6.78333 3.86865 6.78333 4.91723C6.78333 5.96581 5.93796 6.81078 4.88888 6.81078ZM6.51852 18.7422H3.25926V8.24621H6.51852V18.7422ZM20.3704 0.000107732H1.61944C0.73333 0.000107732 0.0101852 0.702553 0 1.58825V20.4118C0.0101852 21.2974 0.73333 22.0101 1.61944 21.9999H20.3704C21.2565 22.0101 21.9898 21.2974 22 20.4118V1.58825C21.9898 0.702553 21.2565 -0.0100726 20.3704 0.000107732Z"
            fill="currentColor"
          />
        </svg>
      )
      break
    case 'linkedin-skelton':
      svg = (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
          <path
            d="M18.7407 18.7422H15.4815V13.6418C15.4815 12.4202 15.4611 10.8626 13.7907 10.8626C12.1204 10.8626 11.8352 12.186 11.8352 13.5604V18.7524H8.57592V8.25639H11.7028V9.69182H11.7435C12.3852 8.60252 13.5667 7.95098 14.8296 7.9917C18.1296 7.9917 18.7407 10.1601 18.7407 12.9903V18.7524V18.7422ZM4.88888 6.81078C3.83981 6.81078 2.99444 5.96581 2.99444 4.91723C2.99444 3.86865 3.83981 3.02368 4.88888 3.02368C5.93796 3.02368 6.78333 3.86865 6.78333 4.91723C6.78333 5.96581 5.93796 6.81078 4.88888 6.81078ZM6.51852 18.7422H3.25926V8.24621H6.51852V18.7422ZM20.3704 0.000107732H1.61944C0.73333 0.000107732 0.0101852 0.702553 0 1.58825V20.4118C0.0101852 21.2974 0.73333 22.0101 1.61944 21.9999H20.3704C21.2565 22.0101 21.9898 21.2974 22 20.4118V1.58825C21.9898 0.702553 21.2565 -0.0100726 20.3704 0.000107732Z"
            fill="currentColor"
          />
        </svg>
      )
      break
    case 'instagram':
      svg = (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
          <path
            d="M17.1506 3.04785H8.74435C7.1018 3.04978 5.5271 3.70321 4.36574 4.86476C3.20438 6.02632 2.55121 7.60114 2.54956 9.24368L2.54956 17.6499C2.55149 19.2925 3.20492 20.8672 4.36647 22.0285C5.52803 23.1899 7.10284 23.8431 8.74539 23.8447H17.1516C18.7942 23.8428 20.3689 23.1894 21.5303 22.0278C22.6916 20.8663 23.3448 19.2914 23.3464 17.6489V9.24264C23.3445 7.60009 22.6911 6.02539 21.5295 4.86403C20.368 3.70267 18.7932 3.04951 17.1506 3.04785V3.04785ZM21.2548 17.6489C21.2548 18.1879 21.1486 18.7215 20.9424 19.2195C20.7361 19.7174 20.4338 20.1699 20.0527 20.551C19.6716 20.9321 19.2191 21.2344 18.7212 21.4406C18.2233 21.6469 17.6896 21.7531 17.1506 21.7531H8.74435C7.65604 21.7528 6.6124 21.3203 5.84294 20.5506C5.07349 19.781 4.64123 18.7372 4.64123 17.6489V9.24264C4.6415 8.15433 5.07403 7.11069 5.84368 6.34123C6.61333 5.57178 7.65708 5.13952 8.74539 5.13952H17.1516C18.24 5.13979 19.2836 5.57232 20.0531 6.34197C20.8225 7.11162 21.2548 8.15537 21.2548 9.24368V17.6499V17.6489Z"
            fill="currentColor"
          />
          <path
            d="M12.9472 8.06836C11.5216 8.07056 10.155 8.63793 9.14705 9.64607C8.1391 10.6542 7.572 12.0209 7.57007 13.4465C7.57172 14.8724 8.13884 16.2395 9.14705 17.2479C10.1553 18.2563 11.5222 18.8237 12.9482 18.8257C14.3743 18.824 15.7416 18.2567 16.75 17.2483C17.7584 16.2399 18.3257 14.8726 18.3274 13.4465C18.3252 12.0205 17.7575 10.6537 16.7489 9.64564C15.7403 8.63763 14.3731 8.07078 12.9472 8.0694V8.06836ZM12.9472 16.734C12.0755 16.734 11.2396 16.3877 10.6233 15.7714C10.0069 15.1551 9.66069 14.3191 9.66069 13.4475C9.66069 12.5759 10.0069 11.74 10.6233 11.1236C11.2396 10.5073 12.0755 10.1611 12.9472 10.1611C13.8188 10.1611 14.6547 10.5073 15.271 11.1236C15.8874 11.74 16.2336 12.5759 16.2336 13.4475C16.2336 14.3191 15.8874 15.1551 15.271 15.7714C14.6547 16.3877 13.8188 16.734 12.9472 16.734Z"
            fill="currentColor"
          />
          <path
            d="M18.3371 9.3974C19.0488 9.3974 19.6257 8.8205 19.6257 8.10885C19.6257 7.39721 19.0488 6.82031 18.3371 6.82031C17.6255 6.82031 17.0486 7.39721 17.0486 8.10885C17.0486 8.8205 17.6255 9.3974 18.3371 9.3974Z"
            fill="currentColor"
          />
        </svg>
      )
      break
  }

  return (
    <div className={style.icon} data-name={name} data-type={type}>
      {svg}
    </div>
  )
}

export default SnsIcon
